var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,253.793,288.17)",
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6EFEC",
    d: "M-190.358,131.913C-190.358,131.913,-245.69,65.261,-218.648,-3.357C-201.022,-48.083,-134.902,-72.591,-97.588,-48.083C-81.695,-37.645,-30.709,-47.732,-3.484,-90.947C49.42,-174.925,234.056,-123.924,200.442,5.011C184.175,67.406,249.948,69.675,216.434,132.045C216.434,132.045,-190.358,131.913,-190.358,131.913Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.105,326.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 8.7; 0; 0",
    keyTimes: "0; 0.498611; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-95.105,-326.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,118.528,308.721)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M-14.137,1.666C-14.137,1.666,-19.717,-4.845,-14.481,-8.98C-14.481,-8.98,-10.656,-11.295,-7.537,-11.107C-7.537,-11.107,-11.957,-3.697,-10.527,-2.96C-9.097,-2.223,-6.198,-11.572,-6.198,-11.572C-6.198,-11.572,2.506,-12.416,5.306,-11.07C5.306,-11.07,-2.135,-4.981,-0.568,-4.619C0.999,-4.257,9.036,-10.233,9.036,-10.233C9.036,-10.233,17.137,-8.854,16.705,-3.912C16.273,1.03,13.482,2.555,12.255,2.424C11.028,2.293,3.852,-0.447,3.696,0.558C3.54,1.563,7.859,4.848,10.884,5.002C10.884,5.002,5.173,11.301,1.377,9.483C-2.419,7.665,-2.743,4.784,-5.109,3.703C-7.475,2.622,-9.495,2.625,-8.518,3.727C-7.541,4.829,-3.259,5.901,-1.906,8.294C-0.553,10.688,0.661,12.302,-3.266,11.711C-7.193,11.12,-13.576,8.246,-13.856,4.956C-14.136,1.666,-14.137,1.666,-14.137,1.666Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,115.374,311.422)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M15.879,-6.48C15.879,-6.48,-6.123,-7.327,-10.982,-1.035C-10.982,-1.035,-12.057,2.182,-15.364,5.113C-15.364,5.113,-15.879,6.518,-15.879,6.518C-15.879,6.518,-12.066,2.498,-10.702,2.255C-10.702,2.255,-12.836,-5.541,15.879,-6.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,98.106,321.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M1.904,-4.628C1.904,-4.628,-2.818,-1.136,-3.146,5.105C-3.146,5.105,-2.289,5.182,-2.289,5.182C-2.289,5.182,-0.781,-1.271,1.945,-3.794C4.671,-6.317,1.904,-4.628,1.904,-4.628Z"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.393,323.728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -4.4; 0; 0",
    keyTimes: "0; 0.498611; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-88.393,-323.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,71.518,294.28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M13.362,7.919C13.362,7.919,22.24,2.948,18.097,-3.798C18.097,-3.798,14.783,-7.941,11.232,-9.006C11.232,-9.006,13.126,1.054,11.232,1.291C9.338,1.528,9.93,-10.071,9.93,-10.071C9.93,-10.071,0.58,-14.569,-3.089,-14.214C-3.089,-14.214,2.71,-4.39,0.816,-4.627C-1.078,-4.864,-7.587,-14.806,-7.587,-14.806C-7.587,-14.806,-17.174,-16.581,-18.713,-10.9C-20.252,-5.219,-17.766,-2.378,-16.346,-2.023C-14.926,-1.668,-5.811,-1.787,-6.048,-0.603C-6.285,0.581,-12.44,2.475,-15.872,1.41C-15.872,1.41,-12.085,10.759,-7.114,10.286C-2.143,9.813,-0.604,6.736,2.473,6.499C5.55,6.262,7.8,7.09,6.261,7.919C4.722,8.748,-0.485,8.191,-2.971,10.304C-5.457,12.417,-7.469,13.719,-2.853,14.666C1.763,15.613,10.048,15.021,11.705,11.47C13.362,7.919,13.362,7.919,13.362,7.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,72.217,298.885)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M-15.032,-13.73C-15.032,-13.73,9.823,-5.681,12.664,3.314C12.664,3.314,12.546,7.338,15.032,11.954C15.032,11.954,15.032,13.73,15.032,13.73C15.032,13.73,12.427,7.694,11.007,6.865C11.007,6.865,16.57,-0.947,-15.032,-13.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,87.815,316.74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M-0.567,-5.901C-0.567,-5.901,3.266,-0.079,1.081,7.006C1.081,7.006,0.095,6.741,0.095,6.741C0.095,6.741,1.052,-1.064,-0.953,-4.989C-2.958,-8.914,-0.567,-5.901,-0.567,-5.901Z"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.118,323.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 6.1; 0; 0",
    keyTimes: "0; 0.498611; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-94.118,-323.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,116.618,284.904)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M-17.614,10.439C-17.614,10.439,-29.316,3.886,-23.855,-5.007C-23.855,-5.007,-19.487,-10.468,-14.806,-11.872C-14.806,-11.872,-17.302,1.39,-14.806,1.702C-12.31,2.014,-13.09,-13.276,-13.09,-13.276C-13.09,-13.276,-0.765,-19.204,4.072,-18.736C4.072,-18.736,-3.572,-5.787,-1.076,-6.099C1.42,-6.411,10.001,-19.517,10.001,-19.517C10.001,-19.517,22.639,-21.857,24.667,-14.368C26.695,-6.879,23.419,-3.135,21.547,-2.667C19.675,-2.199,7.661,-2.354,7.973,-0.794C8.285,0.766,16.397,3.262,20.922,1.858C20.922,1.858,15.93,14.183,9.377,13.559C2.824,12.935,0.796,8.879,-3.26,8.567C-7.317,8.255,-10.281,9.347,-8.253,10.439C-6.225,11.531,0.64,10.797,3.916,13.582C7.192,16.367,9.845,18.084,3.76,19.332C-2.325,20.58,-13.246,19.801,-15.43,15.12C-17.614,10.439,-17.614,10.439,-17.614,10.439Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,115.697,290.975)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M19.814,-18.098C19.814,-18.098,-12.95,-7.489,-16.694,4.368C-16.694,4.368,-16.538,9.673,-19.814,15.758C-19.814,15.758,-19.814,18.098,-19.814,18.098C-19.814,18.098,-16.382,10.141,-14.51,9.049C-14.51,9.049,-21.843,-1.248,19.814,-18.098Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,95.136,314.511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M0.747,-7.778C0.747,-7.778,-4.306,-0.105,-1.425,9.235C-1.425,9.235,-0.125,8.885,-0.125,8.885C-0.125,8.885,-1.387,-1.402,1.257,-6.576C3.901,-11.75,0.747,-7.778,0.747,-7.778Z"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.609,332.539)",
    id: "i6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M0,11.461C12.659,11.461,22.921,1.198,22.921,-11.461C22.921,-11.461,-22.921,-11.461,-22.921,-11.461C-22.921,1.198,-12.659,11.461,0,11.461Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.609,343.752)",
    id: "i7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M23.238,1.414C23.238,1.414,-23.238,1.414,-23.238,1.414C-23.238,1.414,-23.238,1.414,-23.238,1.414C-23.238,-0.148,-21.972,-1.414,-20.41,-1.414C-20.41,-1.414,20.41,-1.414,20.41,-1.414C21.972,-1.414,23.238,-0.148,23.238,1.414C23.238,1.414,23.238,1.414,23.238,1.414Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.493,321.43)",
    id: "i8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M23.559,0.352C23.559,0.352,-23.559,0.352,-23.559,0.352C-23.559,0.352,-23.559,-0.352,-23.559,-0.352C-23.559,-0.352,23.559,-0.352,23.559,-0.352C23.559,-0.352,23.559,0.352,23.559,0.352Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.082,347.497)",
    id: "i9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M34.179,-0.924C34.179,-0.924,34.179,0.924,34.179,0.924C34.179,1.571,33.97,2.099,33.714,2.099C33.714,2.099,-33.714,2.099,-33.714,2.099C-33.97,2.099,-34.179,1.571,-34.179,0.924C-34.179,0.924,-34.179,-0.924,-34.179,-0.924C-34.179,-1.57,-33.97,-2.099,-33.714,-2.099C-33.714,-2.099,33.714,-2.099,33.714,-2.099C33.97,-2.099,34.179,-1.57,34.179,-0.924Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,107.069,347.497)",
    id: "i10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M27.192,-0.924C27.192,-0.924,27.192,0.924,27.192,0.924C27.192,1.571,27,2.099,26.765,2.099C26.765,2.099,-26.765,2.099,-26.765,2.099C-27,2.099,-27.192,1.571,-27.192,0.924C-27.192,0.924,-27.192,-0.924,-27.192,-0.924C-27.192,-1.57,-27,-2.099,-26.765,-2.099C-26.765,-2.099,26.765,-2.099,26.765,-2.099C27,-2.099,27.192,-1.57,27.192,-0.924Z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93.26,384.483)",
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M23.935,34.886C23.935,34.886,-23.935,34.886,-23.935,34.886C-23.935,34.886,-23.935,-34.886,-23.935,-34.886C-23.935,-34.886,23.935,-34.886,23.935,-34.886C23.935,-34.886,23.935,34.886,23.935,34.886Z"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.675,384.483)",
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M23.935,34.886C23.935,34.886,-23.935,34.886,-23.935,34.886C-23.935,34.886,-23.935,-34.886,-23.935,-34.886C-23.935,-34.886,23.935,-34.886,23.935,-34.886C23.935,-34.886,23.935,34.886,23.935,34.886Z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,106.676,383.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M21.363,31.975C21.363,31.975,-21.363,31.975,-21.363,31.975C-21.363,31.975,-21.363,-31.975,-21.363,-31.975C-21.363,-31.975,21.363,-31.975,21.363,-31.975C21.363,-31.975,21.363,31.975,21.363,31.975ZM-20.901,31.513C-20.901,31.513,20.901,31.513,20.901,31.513C20.901,31.513,20.901,-31.513,20.901,-31.513C20.901,-31.513,-20.901,-31.513,-20.901,-31.513C-20.901,-31.513,-20.901,31.513,-20.901,31.513Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,106.676,372.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M21.132,0.231C21.132,0.231,-21.132,0.231,-21.132,0.231C-21.132,0.231,-21.132,-0.231,-21.132,-0.231C-21.132,-0.231,21.132,-0.231,21.132,-0.231C21.132,-0.231,21.132,0.231,21.132,0.231Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,106.676,394.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M21.132,0.231C21.132,0.231,-21.132,0.231,-21.132,0.231C-21.132,0.231,-21.132,-0.231,-21.132,-0.231C-21.132,-0.231,21.132,-0.231,21.132,-0.231C21.132,-0.231,21.132,0.231,21.132,0.231Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,107.085,355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M3.921,0.692C3.921,0.692,-3.921,0.692,-3.921,0.692C-4.302,0.692,-4.613,0.381,-4.613,0C-4.613,0,-4.613,0,-4.613,0C-4.613,-0.381,-4.302,-0.692,-3.921,-0.692C-3.921,-0.692,3.921,-0.692,3.921,-0.692C4.302,-0.692,4.613,-0.381,4.613,0C4.613,0,4.613,0,4.613,0C4.613,0.381,4.302,0.692,3.921,0.692Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,107.085,376.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M3.921,0.692C3.921,0.692,-3.921,0.692,-3.921,0.692C-4.302,0.692,-4.613,0.381,-4.613,0C-4.613,0,-4.613,0,-4.613,0C-4.613,-0.381,-4.302,-0.692,-3.921,-0.692C-3.921,-0.692,3.921,-0.692,3.921,-0.692C4.302,-0.692,4.613,-0.381,4.613,0C4.613,0,4.613,0,4.613,0C4.613,0.381,4.302,0.692,3.921,0.692Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,107.085,398.075)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M3.921,0.692C3.921,0.692,-3.921,0.692,-3.921,0.692C-4.302,0.692,-4.613,0.381,-4.613,0C-4.613,0,-4.613,0,-4.613,0C-4.613,-0.381,-4.302,-0.692,-3.921,-0.692C-3.921,-0.692,3.921,-0.692,3.921,-0.692C4.302,-0.692,4.613,-0.381,4.613,0C4.613,0,4.613,0,4.613,0C4.613,0.381,4.302,0.692,3.921,0.692Z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,307.013,206.969)",
    id: "i18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M15.171,17.176C15.171,17.176,-15.171,17.176,-15.171,17.176C-16.564,17.176,-17.704,16.036,-17.704,14.643C-17.704,14.643,-17.704,-14.643,-17.704,-14.643C-17.704,-16.036,-16.564,-17.176,-15.171,-17.176C-15.171,-17.176,15.171,-17.176,15.171,-17.176C16.564,-17.176,17.704,-16.036,17.704,-14.643C17.704,-14.643,17.704,14.643,17.704,14.643C17.704,16.036,16.564,17.176,15.171,17.176Z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,307.013,206.969)",
    id: "i19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8DDD4",
    d: "M13.857,15.687C13.857,15.687,-13.857,15.687,-13.857,15.687C-15.129,15.687,-16.17,14.646,-16.17,13.374C-16.17,13.374,-16.17,-13.374,-16.17,-13.374C-16.17,-14.646,-15.129,-15.687,-13.857,-15.687C-13.857,-15.687,13.857,-15.687,13.857,-15.687C15.129,-15.687,16.17,-14.646,16.17,-13.374C16.17,-13.374,16.17,13.374,16.17,13.374C16.17,14.646,15.129,15.687,13.857,15.687Z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i21",
    transform: "matrix(1,0,0,1,307.013,194.417)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.733,0C-0.733,-0.405,-0.405,-0.733,0,-0.733C0.405,-0.733,0.733,-0.405,0.733,0C0.733,0.405,0.405,0.733,0,0.733C-0.405,0.733,-0.733,0.405,-0.733,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,312.839,195.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.641,-0.356C-0.444,-0.71,0.002,-0.838,0.356,-0.641C0.71,-0.444,0.838,0.002,0.641,0.356C0.444,0.71,-0.002,0.838,-0.356,0.641C-0.71,0.444,-0.838,-0.002,-0.641,-0.356Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,317.666,200.098)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.398,-0.616C-0.058,-0.836,0.396,-0.738,0.616,-0.398C0.835,-0.058,0.738,0.396,0.398,0.616C0.058,0.836,-0.396,0.738,-0.616,0.398C-0.836,0.058,-0.738,-0.396,-0.398,-0.616Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,319.779,206.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0,-0.733C0.405,-0.733,0.733,-0.405,0.733,0C0.733,0.405,0.405,0.733,0,0.733C-0.405,0.733,-0.733,0.405,-0.733,0C-0.733,-0.405,-0.405,-0.733,0,-0.733Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,317.979,213.471)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0.519,-0.519C0.805,-0.233,0.805,0.233,0.519,0.519C0.233,0.805,-0.233,0.805,-0.519,0.519C-0.805,0.233,-0.805,-0.233,-0.519,-0.519C-0.233,-0.805,0.233,-0.805,0.519,-0.519Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,313.373,218.089)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0.519,-0.519C0.806,-0.233,0.806,0.233,0.519,0.519C0.233,0.805,-0.233,0.805,-0.519,0.519C-0.805,0.233,-0.805,-0.233,-0.519,-0.519C-0.233,-0.805,0.233,-0.805,0.519,-0.519Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,307.013,219.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.733,0C-0.733,-0.405,-0.405,-0.733,0,-0.733C0.405,-0.733,0.733,-0.405,0.733,0C0.733,0.405,0.405,0.733,0,0.733C-0.405,0.733,-0.733,0.405,-0.733,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,301.163,195.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0.641,-0.356C0.444,-0.71,-0.002,-0.838,-0.356,-0.641C-0.71,-0.444,-0.838,0.002,-0.641,0.356C-0.444,0.71,0.002,0.838,0.356,0.641C0.71,0.444,0.838,-0.002,0.641,-0.356Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,296.337,200.098)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0.398,-0.616C0.058,-0.836,-0.397,-0.738,-0.616,-0.398C-0.836,-0.058,-0.738,0.396,-0.398,0.616C-0.058,0.836,0.397,0.738,0.616,0.398C0.836,0.058,0.738,-0.396,0.398,-0.616Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,294.223,206.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0,-0.733C-0.405,-0.733,-0.733,-0.405,-0.733,0C-0.733,0.405,-0.405,0.733,0,0.733C0.405,0.733,0.733,0.405,0.733,0C0.733,-0.405,0.405,-0.733,0,-0.733Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,296.024,213.471)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.519,-0.519C-0.805,-0.233,-0.805,0.233,-0.519,0.519C-0.233,0.805,0.233,0.805,0.519,0.519C0.806,0.233,0.806,-0.233,0.519,-0.519C0.233,-0.805,-0.233,-0.805,-0.519,-0.519Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,300.629,218.089)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.519,-0.519C-0.805,-0.233,-0.805,0.233,-0.519,0.519C-0.233,0.805,0.233,0.805,0.519,0.519C0.805,0.233,0.805,-0.233,0.519,-0.519C0.233,-0.805,-0.233,-0.805,-0.519,-0.519Z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,307.548,206.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-0.733,0C-0.733,-0.405,-0.405,-0.733,0,-0.733C0.405,-0.733,0.733,-0.405,0.733,0C0.733,0.405,0.405,0.733,0,0.733C-0.405,0.733,-0.733,0.405,-0.733,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,307.548,201.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M0.1,4.581C0.1,4.581,-0.1,4.581,-0.1,4.581C-0.1,4.581,-0.1,-4.581,-0.1,-4.581C-0.1,-4.581,0.1,-4.581,0.1,-4.581C0.1,-4.581,0.1,4.581,0.1,4.581Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,309.885,204.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FC9BB",
    d: "M-2.243,2.143C-2.243,2.143,-2.614,1.67,-2.614,1.67C-2.614,1.67,2.243,-2.143,2.243,-2.143C2.243,-2.143,2.614,-1.67,2.614,-1.67C2.614,-1.67,-2.243,2.143,-2.243,2.143Z"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,426.836,387.93)",
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M4.114,31.676C4.114,31.676,4.227,31.674,4.227,31.674C5.153,31.657,5.868,30.9,5.781,30.029C5.781,30.029,-0.397,-31.676,-0.397,-31.676C-0.397,-31.676,-5.789,-31.195,-5.789,-31.195C-5.789,-31.195,3.083,30.842,3.083,30.842C3.152,31.327,3.596,31.685,4.114,31.676Z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,395.035,387.93)",
    id: "i24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M4.114,31.676C4.114,31.676,4.227,31.674,4.227,31.674C5.153,31.657,5.868,30.9,5.781,30.029C5.781,30.029,-0.397,-31.676,-0.397,-31.676C-0.397,-31.676,-5.789,-31.195,-5.789,-31.195C-5.789,-31.195,3.083,30.842,3.083,30.842C3.152,31.327,3.596,31.685,4.114,31.676Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,402.031,352.217)",
    id: "i25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M24.705,4.939C24.705,4.939,-24.706,4.939,-24.706,4.939C-26.012,4.939,-27.079,3.871,-27.079,2.565C-27.079,2.565,-27.079,-2.565,-27.079,-2.565C-27.079,-3.871,-26.012,-4.939,-24.706,-4.939C-24.706,-4.939,27.079,-4.939,27.079,-4.939C27.079,-4.939,27.079,2.565,27.079,2.565C27.079,3.871,26.011,4.939,24.705,4.939Z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,212.77,387.93)",
    id: "i26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M4.114,31.676C4.114,31.676,4.227,31.674,4.227,31.674C5.153,31.657,5.868,30.9,5.781,30.029C5.781,30.029,-0.397,-31.676,-0.397,-31.676C-0.397,-31.676,-5.789,-31.195,-5.789,-31.195C-5.789,-31.195,3.083,30.842,3.083,30.842C3.152,31.327,3.596,31.685,4.114,31.676Z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,161.504,387.93)",
    id: "i27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-4.114,31.676C-4.114,31.676,-4.227,31.674,-4.227,31.674C-5.153,31.657,-5.868,30.9,-5.781,30.029C-5.781,30.029,0.397,-31.676,0.397,-31.676C0.397,-31.676,5.789,-31.195,5.789,-31.195C5.789,-31.195,-3.083,30.842,-3.083,30.842C-3.152,31.327,-3.596,31.685,-4.114,31.676Z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,256.358,387.93)",
    id: "i28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M4.114,31.676C4.114,31.676,4.227,31.674,4.227,31.674C5.153,31.657,5.868,30.9,5.781,30.029C5.781,30.029,-0.397,-31.676,-0.397,-31.676C-0.397,-31.676,-5.789,-31.195,-5.789,-31.195C-5.789,-31.195,3.083,30.842,3.083,30.842C3.152,31.327,3.596,31.685,4.114,31.676Z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,180.873,313.268)",
    id: "i29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-21.643,34.011C-21.643,34.011,-32.61,-20.149,-32.61,-20.149C-34.018,-27.482,-27.942,-34.187,-20.052,-34.007C-20.052,-34.007,1.099,-33.524,1.099,-33.524C8.396,-33.357,14.74,-28.474,16.768,-21.463C16.768,-21.463,32.814,34.011,32.814,34.011C32.814,34.011,-21.643,34.011,-21.643,34.011Z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.508,313.268)",
    id: "i30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-21.643,34.011C-21.643,34.011,-32.61,-20.149,-32.61,-20.149C-34.018,-27.482,-27.942,-34.187,-20.052,-34.007C-20.052,-34.007,1.099,-33.524,1.099,-33.524C8.396,-33.357,14.74,-28.474,16.768,-21.463C16.768,-21.463,32.814,34.011,32.814,34.011C32.814,34.011,-21.643,34.011,-21.643,34.011Z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,204.128,352.217)",
    id: "i31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-41.841,4.939C-41.841,4.939,41.841,4.939,41.841,4.939C43.522,4.939,44.898,3.563,44.898,1.882C44.898,1.882,44.898,-1.882,44.898,-1.882C44.898,-3.563,43.522,-4.939,41.841,-4.939C41.841,-4.939,-44.898,-4.939,-44.898,-4.939C-44.898,-4.939,-44.898,1.882,-44.898,1.882C-44.898,3.563,-43.522,4.939,-41.841,4.939Z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,228.23,352.217)",
    id: "i32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-26.673,4.939C-26.673,4.939,26.673,4.939,26.673,4.939C28.027,4.939,29.135,3.831,29.135,2.477C29.135,2.477,29.135,-2.477,29.135,-2.477C29.135,-3.831,28.027,-4.939,26.673,-4.939C26.673,-4.939,-26.673,-4.939,-26.673,-4.939C-28.027,-4.939,-29.135,-3.831,-29.135,-2.477C-29.135,-2.477,-29.135,2.477,-29.135,2.477C-29.135,3.831,-28.027,4.939,-26.673,4.939Z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,351.157,368.566)",
    id: "i33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M8.78,51.492C8.78,51.492,8.852,51.483,8.852,51.483C9.712,51.377,10.322,50.61,10.213,49.769C10.213,49.769,-4.748,-51.502,-4.748,-51.502C-4.748,-51.502,-10.225,-51.345,-10.225,-51.345C-10.225,-51.345,7.377,50.473,7.377,50.473C7.49,51.125,8.109,51.575,8.78,51.492Z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,363.642,367.124)",
    id: "i34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-43.102,45.261)",
    id: "i35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-15.324,7.591C-15.324,7.591,14.364,7.591,14.364,7.591C15.792,5.848,15.265,-0.582,15.049,-2.681C15.004,-3.104,14.974,-3.35,14.974,-3.35C14.974,-3.35,4.837,-11.459,3.444,-5.25C3.402,-5.055,3.349,-4.865,3.293,-4.677C1.539,1.13,-6.33,3.77,-10.874,4.505C-13.828,4.984,-14.92,6.52,-15.324,7.591Z"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,363.642,367.124)",
    id: "i34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M22.581,-43.615C21.509,-43.615,-28.273,-34.268,-36.507,-24.075C-40.621,-18.983,-41.232,39.825,-41.232,39.825C-41.232,39.825,-36.143,46.135,-25.152,42.471C-25.152,42.471,-17.093,2.236,-17.688,-9.968C-17.853,-13.343,16.325,-10.456,22.581,-12.075C28.837,-13.694,44.121,-27.302,40.753,-33.932C37.385,-40.562,22.581,-43.615,22.581,-43.615Z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.904,256.958)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3.8; 0; 3.8; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-26.25,28.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.073,25.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 8.9; 0; 8.9; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-8.5,1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M9.267,-2.5C9.267,-2.5,-0.774,-2.364,-3.149,-1.346C-5.524,-0.328,-10.341,2.007,-9.052,2.366C-7.763,2.724,-1.611,2.218,-0.282,2.422C1.047,2.626,2.686,2.366,3.5,2.366C4.314,2.366,8.112,2.366,8.112,2.366C8.112,2.366,9.267,-2.5,9.267,-2.5Z"
  }))))))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,385.21,295.582)",
    id: "i38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i39"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.363,-25.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 4.3; 0; 4.3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-27.5,7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.219,4.226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 10.3; 0; 10.3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-7.25,-3.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M9.73,6.686C9.73,6.686,6.307,4.24,2.982,3.765C1.086,3.494,-0.758,3.156,-1.872,2.763C-4.94,1.682,-11.077,-3.836,-10.613,-4.484C-9.124,-6.559,-1.959,-2.168,-0.708,-2.639C0.543,-3.11,-3.112,-5.709,-1.841,-6.623C-1.177,-7.1,0.376,-4.708,1.646,-4.468C3.364,-4.143,4.706,-1.718,5.223,-1.591C6.23,-1.345,10.638,1.934,10.638,1.934C10.638,1.934,9.73,6.686,9.73,6.686Z"
  })))))))))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.904,256.958)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3.8; 0; 3.8; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-26.25,28.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed7d2b",
    d: "M26.611,-28.767C26.611,-28.767,18.966,-26.398,11.435,-5.659C3.904,15.08,1.044,16.2,-1.694,17.014C-4.432,17.828,-28.46,22.612,-28.46,22.612C-28.46,22.612,-28.46,28.767,-28.46,28.767C-28.46,28.767,8.565,28.767,8.565,28.767C8.565,28.767,22.449,15.56,26.611,6.669C30.773,-2.222,26.611,-28.767,26.611,-28.767Z"
  }))))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.472,340.374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3.7; 0; 3.7; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-20.5,26.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i42"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.803,41.511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3; 0; 3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-7.75,3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-15.324,7.591C-15.324,7.591,14.363,7.591,14.363,7.591C15.791,5.848,15.265,-0.582,15.049,-2.681C15.005,-3.104,14.974,-3.35,14.974,-3.35C14.974,-3.35,4.837,-11.459,3.444,-5.25C3.402,-5.055,3.349,-4.865,3.293,-4.677C1.539,1.13,-6.33,3.77,-10.874,4.505C-13.828,4.984,-14.92,6.52,-15.324,7.591Z"
  }))))))))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.472,340.374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3.7; 0; 3.7; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0.333 0 0.4 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-20.5,26.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F6E56",
    d: "M22.581,-43.615C21.509,-43.615,-28.273,-34.268,-36.507,-24.075C-40.621,-18.983,-41.232,39.825,-41.232,39.825C-41.232,39.825,-36.142,46.135,-25.151,42.471C-25.151,42.471,-17.093,2.236,-17.688,-9.968C-17.853,-13.343,16.325,-10.456,22.581,-12.075C28.836,-13.694,44.121,-27.302,40.753,-33.932C37.385,-40.562,22.581,-43.615,22.581,-43.615Z"
  }))))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.716,258.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3.6; 0; -3.6; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.375,-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-6.672,13.307C-3.091,13.011,0.664,12.057,3.909,11.004C7.966,9.688,11.236,7.764,9.129,4.056C7.187,0.639,4.044,-6.995,4.256,-13.319C4.256,-13.319,-3.293,-7.235,-3.293,-7.235C-3.293,-7.235,-8.42,-3.104,-8.42,-3.104C-8.42,-3.104,-8.399,-0.668,-7.839,3.601C-7.737,4.379,-7.616,5.219,-7.475,6.117C-7.361,6.842,-7.694,7.567,-8.318,7.954C-8.357,7.978,-8.396,8.002,-8.434,8.026C-10.982,9.627,-9.672,13.555,-6.672,13.307Z"
  }))))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.716,258.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3.6; 0; -3.6; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.375,-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.942,-3.622)",
    id: "i44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M-4.479,-0.487C-4.479,-0.487,-4.741,0.397,-4.29,3.663C0.281,2.917,4.555,-0.729,4.555,-0.729C2.228,-1.368,1.381,-3.883,-0.353,-3.648C-0.353,-3.648,-4.479,-0.487,-4.479,-0.487Z"
  })))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.716,258.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3.6; 0; -3.6; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.375,-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.848,-17.734)",
    id: "i45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-8.801,14.369C-8.801,14.369,8.783,17.291,10.434,6.312C12.085,-4.667,15.465,-11.684,4.308,-14.013C-6.849,-16.342,-9.665,-12.481,-11.107,-8.951C-12.549,-5.421,-13.332,13.326,-8.801,14.369Z"
  })))))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.716,258.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3.6; 0; -3.6; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.375,-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2.709,-19.756)",
    id: "i46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F6E56",
    d: "M-14.832,-11.788C-15.587,-9.144,-13.566,-5.924,-10.174,-4.864C-5.138,-3.29,-6.251,2.887,-3.985,2.803C-1.719,2.719,-0.805,-0.748,1.219,2.022C2.945,4.384,-0.218,7.186,0,8.481C0.374,10.705,3.858,15.255,6.997,15.027C10.137,14.799,16.011,-0.122,14.836,-4.738C13.661,-9.354,8.961,-14.222,4.513,-14.893C0.065,-15.564,-6.112,-13.644,-7.539,-13.644C-8.966,-13.644,-14.424,-13.216,-14.832,-11.788Z"
  })))))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,385.21,295.582)",
    id: "i38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M19.419,-23.904C16.878,-34.133,9.854,-44.868,5.104,-44.859C-2.99,-44.844,-14.624,-42.708,-19.322,-31.119C-22.782,-22.584,-27.398,26.512,-22.182,30.004C-10.259,37.986,17.379,54.281,22.288,37.664C26.786,22.439,23.83,-6.15,19.419,-23.904Z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,385.21,295.582)",
    id: "i38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i39"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.363,-25.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 4.3; 0; 4.3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-27.5,7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M36.625,-15.85C34.316,-21.856,26.869,-23.932,21.79,-19.981C19.043,-17.844,15.679,-14.801,11.616,-10.474C-3.488,5.61,-6.558,5.51,-9.395,5.178C-12.232,4.846,-36.198,-0.241,-36.198,-0.241C-36.198,-0.241,-37.426,0.665,-38.148,2.128C-39.113,4.083,-38.627,5.414,-38.627,5.414C-39.566,4.807,-30.131,11.311,-25.435,13.904C-19.233,17.328,-9.889,20.539,-6.167,21.758C-5.112,22.104,-3.974,22.086,-2.93,21.71C2.594,19.719,21.146,12.462,36.248,-0.128C40.227,-3.445,38.766,-10.281,36.625,-15.85Z"
  })))))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "i43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.716,258.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3.6; 0; -3.6; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.375,-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.708,2.325)",
    id: "i47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10.496,-1.208C10.496,-1.208,8.663,-5.336,8.663,-5.336C8.663,-5.336,-7.739,-3.999,-10.496,5.336C-10.496,5.336,2.219,-1.008,10.496,-1.208Z"
  })))))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.933,331.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.5,23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.144,-14.242)",
    id: "i48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M16.842,-4.815C12.315,3.064,6.621,6.106,6.621,6.106C6.621,6.106,-17.068,6.106,-17.068,6.106C-17.068,6.106,20.296,-10.826,16.842,-4.815Z"
  })))))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.933,331.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.5,23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.638,46.824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.1; 0; -6.1; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(7.5,6.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-11.223,5.9C-11.479,8.385,-8.022,9.027,-4.013,9.27C-0.004,9.513,-1.225,10.321,4.262,11.376C9.749,12.431,11.968,10.95,12.374,10.211C12.735,9.556,10.19,8.498,7.479,7.304C7.138,7.155,6.796,7.002,6.454,6.848C3.403,5.467,1.713,2.7,-0.65,0.125C-2.888,-2.314,-4.955,-10.067,-4.955,-10.067C-4.955,-10.067,-12.408,-11.743,-12.408,-11.743C-12.408,-11.743,-10.385,-4.763,-9.689,-1.785C-9.279,-0.033,-9.932,1.913,-10.509,3.394C-10.82,4.2,-11.134,5.024,-11.223,5.9Z"
  }))))))))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.933,331.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.5,23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.638,46.824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.1; 0; -6.1; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(7.5,6.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.586,7.568)",
    id: "i42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-4.599,1.702C-0.59,1.945,-1.811,2.753,3.676,3.808C9.163,4.863,11.382,3.382,11.788,2.643C12.149,1.988,9.604,0.93,6.893,-0.264C6.893,-0.264,6.85,-0.218,6.85,-0.218C6.85,-0.218,2.971,1.053,-1.478,-0.208C-5.104,-1.234,-8.597,-3.446,-11.095,-4.175C-11.406,-3.369,-11.72,-2.545,-11.809,-1.669C-12.065,0.816,-8.608,1.459,-4.599,1.702Z"
  })))))))))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "i41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.933,331.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.5,23.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M25.623,-27.128C21.612,-29.944,-4.917,-34.965,-18.456,-36.417C-18.456,-36.417,-33.42,-49.406,-33.42,-49.406C-33.42,-49.406,-46.158,-30.541,-46.259,-16.108C-46.306,-9.378,-43.206,-8.71,-43.205,-8.709C-43.205,-8.709,4.765,-8.353,6.868,-8.136C10.31,-7.781,14.85,0.793,15.985,8.603C17.12,16.413,37.123,48.176,37.123,48.176C37.123,48.176,41.295,49.513,43.224,49.4C45.299,49.278,46.259,48.583,46.259,48.583C46.259,48.583,34.668,-20.777,25.623,-27.128Z"
  }))))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "i34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.165,333.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.75,22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.873,44.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -10.7; 0; -10.7; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(8.375,8.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-11.223,5.9C-11.479,8.385,-8.022,9.027,-4.013,9.27C-0.004,9.513,-1.225,10.321,4.262,11.376C9.749,12.431,11.968,10.95,12.374,10.211C12.735,9.556,10.19,8.498,7.479,7.304C7.138,7.155,6.796,7.002,6.454,6.848C3.403,5.467,1.713,2.7,-0.65,0.125C-2.888,-2.314,-4.955,-10.067,-4.955,-10.067C-4.955,-10.067,-12.408,-11.743,-12.408,-11.743C-12.408,-11.743,-10.385,-4.763,-9.689,-1.785C-9.279,-0.033,-9.932,1.913,-10.509,3.394C-10.82,4.2,-11.134,5.024,-11.223,5.9Z"
  }))))))))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "i34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.165,333.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.75,22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.873,44.949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -10.7; 0; -10.7; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(8.375,8.375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.586,7.568)",
    id: "i35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-4.599,1.702C-0.59,1.945,-1.811,2.753,3.676,3.808C9.163,4.863,11.382,3.382,11.788,2.643C12.149,1.988,9.604,0.93,6.893,-0.264C6.893,-0.264,6.85,-0.218,6.85,-0.218C6.85,-0.218,2.971,1.053,-1.478,-0.208C-5.104,-1.234,-8.597,-3.446,-11.095,-4.175C-11.406,-3.369,-11.72,-2.545,-11.809,-1.669C-12.065,0.816,-8.608,1.459,-4.599,1.702Z"
  })))))))))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "i34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.165,333.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0.333 0 0.2 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(28.75,22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F6E56",
    d: "M25.623,-27.128C22.139,-29.575,11.659,-31.471,0.091,-32.879C-3.107,-33.268,-5.733,-35.593,-6.514,-38.719C-6.514,-38.719,-6.514,-38.719,-6.514,-38.719C-6.514,-38.719,-33.42,-49.406,-33.42,-49.406C-33.42,-49.406,-46.158,-30.541,-46.259,-16.108C-46.306,-9.378,-43.206,-8.71,-43.205,-8.709C-43.205,-8.709,4.765,-8.353,6.868,-8.136C10.31,-7.781,14.85,0.793,15.985,8.603C17.12,16.413,37.123,48.176,37.123,48.176C37.123,48.176,41.295,49.513,43.224,49.4C45.299,49.278,46.259,48.583,46.259,48.583C46.259,48.583,34.668,-20.777,25.623,-27.128Z"
  }))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.502,-17.437)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3.7; 0; 3.7; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(61.5,14.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-54.466,-28.789C-58.163,-30.731,-63.79,-30.993,-64.704,-31.116C-75.641,-32.586,-82.224,-16.694,-82.611,-11.878C-83.324,-3.002,-88.021,-1.648,-94.63,3.911C-107.883,15.057,-103.996,28.009,-96.749,32.822C-92.401,35.71,-84.738,32.822,-84.738,32.822C-84.63,32.898,-63.778,21.165,-53.5,15.506C-38.092,13.316,-45.044,-23.841,-54.466,-28.789Z"
  })))))))))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M7.255,6.852C7.303,6.877,2.395,9.109,-1.148,7.938C-4.481,6.84,-7.416,1.822,-7.369,1.815C-5.922,1.605,-4.452,0.178,-4.042,-8.278C-4.042,-8.278,-3.401,-8.116,-3.401,-8.116C-3.401,-8.116,7.37,-5.394,7.37,-5.394C7.37,-5.394,6.944,-1.982,6.768,1.244C6.619,3.953,6.65,6.53,7.255,6.852Z"
  })))))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.833,-4.452)",
    id: "i44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M5.537,-0.942C5.537,-0.942,5.537,-0.24,5.134,2.934C-0.957,1.398,-3.643,-0.622,-5.537,-2.934C-5.537,-2.934,5.537,-0.942,5.537,-0.942Z"
  }))))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.586,-16.613)",
    id: "i54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M7.081,11.648C7.081,11.648,-7.161,13.967,-8.469,5.075C-9.777,-3.817,-12.495,-9.505,-3.457,-11.362C5.581,-13.219,7.851,-10.087,9.009,-7.225C10.167,-4.363,10.752,10.816,7.081,11.648Z"
  }))))))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.745,-22.078)",
    id: "i55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M10.426,-6.27C10.426,-6.27,3.958,3.94,-1.816,6.358C-7.59,8.776,-10.426,7.549,-10.426,7.549C-10.426,7.549,-7.799,3.566,-7.115,-1.782C-6.913,-3.358,-5.886,-4.71,-4.411,-5.301C-0.268,-6.96,7.747,-9.578,10.426,-6.27Z"
  }))))))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.539,-28.16)",
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8.461,-22.509)",
    id: "i56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-4.462,-4.852C-4.462,-4.852,-0.67,-2.909,0.891,-1.087C2.398,0.671,4.137,5.441,4.013,7.583C4.013,7.583,5.883,-2.682,1.988,-6.211C-2.142,-9.953,-4.462,-4.852,-4.462,-4.852Z"
  }))))))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M19.188,0.415C18.756,29.366,19.07,23.316,15.903,26.063C15.14,26.724,12.994,27.118,10.171,27.305C1.294,27.894,-14.311,26.432,-14.905,24.791C-16.953,19.114,-15.507,17.351,-17.215,8.66C-17.393,7.736,-17.613,6.735,-17.872,5.646C-19.296,-0.323,-20.683,-2.353,-15.63,-11.943C-11.047,-20.63,-5.658,-27.686,-5.23,-27.432C6.861,-20.255,7.275,-26.271,7.275,-26.271C7.275,-26.271,19.4,-13.706,19.188,0.415Z"
  }))))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i39"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.472,-26.012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -2.2; 0; -2.2; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(11.75,22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-11.947,-22.259C-11.947,-22.259,0.428,-20.162,1.889,-14.805C3.35,-9.448,11.947,22.042,11.947,22.042C11.947,22.042,5.622,23.178,2.7,20.256C-0.222,17.334,-7.466,-6.851,-7.466,-6.851C-7.466,-6.851,-11.947,-22.259,-11.947,-22.259Z"
  }))))))))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.936,299.368)",
    id: "i57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6EFEC",
    d: "M13.693,15.284C4.816,15.873,-10.789,14.411,-11.383,12.77C-13.431,7.093,-11.985,5.33,-13.693,-3.361C-13.693,-3.361,-9.411,-15.417,-9.411,-15.417C-9.411,-15.417,-10.12,-1.991,-6.16,1.54C-2.205,5.071,10.051,8.357,11.976,11.308C12.904,12.724,13.515,14.144,13.693,15.284Z"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.661,-27.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.4; 0; -6.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-10.75,27.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.664,23.084)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -4.4; 0; -4.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(7.5,-0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-7.753,-1.335C-7.753,-1.335,1.005,-3.285,2.418,-2.508C3.831,-1.731,7.285,1.1,7.717,2.085C8.149,3.07,4.571,1.337,3.407,1.025C2.653,0.823,0.669,1.513,-0.313,1.84C-4.446,3.218,-6.979,2.509,-6.979,2.509C-6.979,2.509,-7.753,-1.335,-7.753,-1.335Z"
  }))))))))))))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.661,-27.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.4; 0; -6.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-10.75,27.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.181,-27.841C11.181,-27.841,-1.214,-27.117,-5.285,-21.439C-11.016,-13.446,-22.384,20.617,-15.869,25.16C-8.532,30.276,17.524,26.498,17.524,26.498C17.524,26.498,18.39,22.445,17.184,20.485C15.978,18.524,-3.626,15.358,-4.531,14.453C-5.436,13.548,6.779,-3.192,6.779,-5.906C6.779,-8.621,11.181,-27.841,11.181,-27.841Z"
  }))))))))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.661,-27.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.4; 0; -6.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-10.75,27.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.664,23.084)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -4.4; 0; -4.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(7.5,-0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.555,1.364)",
    id: "i58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-1.713,-1.435C-1.713,-1.435,0.121,0.932,0.723,1.215C1.325,1.498,1.713,1.427,1.713,1.427C1.713,1.427,0.477,-0.799,0.477,-0.799C0.477,-0.799,-1.713,-1.435,-1.713,-1.435Z"
  })))))))))))))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.209,314.597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 5; 0; 5; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-0.75,-27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.661,-27.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6.4; 0; -6.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-10.75,27.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.664,23.084)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -4.4; 0; -4.4; 0; 0",
    keyTimes: "0; 0.25; 0.5; 0.75; 0.997222; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(7.5,-0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.086,-1.041)",
    id: "i59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M-2.668,-1.467C-2.668,-1.467,2.668,1.124,2.668,1.124C2.668,1.124,2.441,1.495,1.784,1.465C1.127,1.435,-0.53,0.829,-0.53,0.829C-0.53,0.829,-2.668,-1.467,-2.668,-1.467Z"
  })))))))))))))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,271.883,317.01)",
    id: "i60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-83.944,3.036C-83.944,3.036,83.944,3.036,83.944,3.036C84.65,3.036,85.222,2.463,85.222,1.757C85.222,1.757,85.222,-1.757,85.222,-1.757C85.222,-2.463,84.65,-3.036,83.944,-3.036C83.944,-3.036,-83.944,-3.036,-83.944,-3.036C-84.65,-3.036,-85.222,-2.463,-85.222,-1.757C-85.222,-1.757,-85.222,1.757,-85.222,1.757C-85.222,2.463,-84.65,3.036,-83.944,3.036Z"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,191.098,368.566)",
    id: "i61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-8.78,51.492C-8.78,51.492,-8.852,51.483,-8.852,51.483C-9.712,51.377,-10.322,50.61,-10.213,49.769C-10.213,49.769,4.748,-51.502,4.748,-51.502C4.748,-51.502,10.225,-51.345,10.225,-51.345C10.225,-51.345,-7.377,50.473,-7.377,50.473C-7.49,51.125,-8.109,51.575,-8.78,51.492Z"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,225.733,368.566)",
    id: "i62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A5544",
    d: "M-8.78,51.492C-8.78,51.492,-8.852,51.483,-8.852,51.483C-9.712,51.377,-10.322,50.61,-10.213,49.769C-10.213,49.769,4.748,-51.502,4.748,-51.502C4.748,-51.502,10.225,-51.345,10.225,-51.345C10.225,-51.345,-7.377,50.473,-7.377,50.473C-7.49,51.125,-8.109,51.575,-8.78,51.492Z"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,208.894,312.987)",
    id: "i63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed7d2b",
    d: "M12.39,0.988C12.39,0.988,-12.39,0.988,-12.39,0.988C-12.39,0.988,-12.39,0.988,-12.39,0.988C-12.39,-0.103,-11.505,-0.988,-10.414,-0.988C-10.414,-0.988,12.39,-0.988,12.39,-0.988C12.39,-0.988,12.39,0.988,12.39,0.988Z"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,235.649,300.481)",
    id: "i64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed7d2b",
    d: "M-14.436,-13.493C-14.436,-13.493,23.874,-13.493,23.874,-13.493C23.874,-13.493,14.685,13.493,14.685,13.493C14.685,13.493,-23.874,13.493,-23.874,13.493C-23.874,13.493,-14.436,-13.493,-14.436,-13.493Z"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,236.213,300.481)",
    id: "i65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M23.874,-13.494C23.874,-13.494,14.685,13.494,14.685,13.494C14.685,13.494,-23.874,13.494,-23.874,13.494C-23.874,13.494,-14.436,-13.494,-14.436,-13.494C-14.436,-13.494,23.874,-13.494,23.874,-13.494Z"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,237.565,300.232)",
    id: "i66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.867,0C1.629,1.031,0.6,1.867,-0.431,1.867C-1.462,1.867,-2.105,1.031,-1.867,0C-1.629,-1.031,-0.6,-1.867,0.431,-1.867C1.462,-1.867,2.105,-1.031,1.867,0Z"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.074,315.883)",
    id: "i67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M24.13,31.63C24.13,31.63,29.994,-19.907,29.994,-19.907C30.763,-27.334,28.277,-34.606,17.56,-35.169C17.56,-35.169,-1.295,-36.318,-1.295,-36.318C-12.47,-36.779,-17.515,-27.478,-18.93,-20.318C-18.93,-20.318,-30.123,36.334,-30.123,36.334C-30.123,36.334,24.13,31.63,24.13,31.63Z"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,384.212,352.217)",
    id: "i68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M41.841,4.939C41.841,4.939,-41.841,4.939,-41.841,4.939C-43.522,4.939,-44.898,3.563,-44.898,1.882C-44.898,1.882,-44.898,-1.882,-44.898,-1.882C-44.898,-3.563,-43.522,-4.939,-41.841,-4.939C-41.841,-4.939,44.898,-4.939,44.898,-4.939C44.898,-4.939,44.898,1.882,44.898,1.882C44.898,3.563,43.522,4.939,41.841,4.939Z"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,343.559,387.93)",
    id: "i69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A9A80",
    d: "M-4.114,31.676C-4.114,31.676,-4.227,31.674,-4.227,31.674C-5.153,31.657,-5.868,30.9,-5.781,30.029C-5.781,30.029,0.397,-31.676,0.397,-31.676C0.397,-31.676,5.789,-31.195,5.789,-31.195C5.789,-31.195,-3.083,30.842,-3.083,30.842C-3.152,31.327,-3.596,31.685,-4.114,31.676Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountant);
export default __webpack_public_path__ + "static/media/my-accountant.823099b20da18d2a5ed7e464b9eb0b07.svg";
export { ForwardRef as ReactComponent };